import { selectors as authSelectors } from '@hixme/auth-ui'
import { ROLE_PLATFORM_HIXME_ADMIN } from '@hixme/role-policy'
import { useSelector } from 'react-redux'

/**
 * Customer Configuration history is visible to Platform Hixme Admins only.
 * UI gate: the activity-log API itself is not scoped by this check.
 */
export default function useCanViewConfigurationHistory(): boolean {
  const role = useSelector(authSelectors.getRole)
  return role === ROLE_PLATFORM_HIXME_ADMIN
}
